import { post } from '@/lib/request/index';
import { account } from '../apiConstants';
import { Message } from '@didi/r-fusion-pc';
// 查询账户信息
export async function queryAccount(param) {
  return post(account.QUERY_ACCOUNT, { param })
    .then((data) => data)
    .catch((err) => {
      console.log('err', err);
      return err;
    });
}

// 添加账户信息
export async function addAccount(param) {
  return post(account.ADD_ACCOUNT, { param })
    .then((data) => data)
    .catch((err) => {
      console.log('err', err);
      const { errno, errmsg } = err;
      // 风控提示
      if (errno === 100001 || errno === 100002) Message.error(errmsg);
      return false;
    });
}

// 更新账户信息
export function updateAccount(param) {
  return post(account.UPDATE_ACCOUNT, { param })
    .then((data) => data)
    .catch((err) => {
      console.log('err', err);
      const { errno, errmsg } = err;
      // 风控提示
      if (errno === 100001 || errno === 100002) Message.error(errmsg);
      return false;
    });
}
